export default {
  type: 'email_list_owner',
  name: 'Email List Owners',
  description: 'Email list owner information',
  search: {
    search: 'allEmailLists',
    orderBy: {
      type: 'EmailListsOrderBy',
      default: 'EMAIL_LIST_ASC'
    },
    fields: [
      {
        name: 'emailList',
        label: 'List',
        searchable: false,
        order: 'EMAIL_LIST'
      },
      {
        alias: 'owner',
        searchable: false,
        order: 'ROLE_NAME',
        join: 'roleByRoleName',
        fields: [
          'roleName',
          {
            join: 'rolePeopleByRoleName',
            nodes: true,
            fields: [
              {
                join: 'personByPersonId',
                fields: ['fullName']
              }
            ]
          }
        ]
      },
      [
        {
          name: 'statusList',
          label: 'Moderation Status',
          width: 6,
          type: 'select',
          order: 'STATUS_LIST',
          options: [
            { value: null, text: 'All' },
            {
              value: 'armpublic',
              text: 'Non-Moderated (Public, no attachments)'
            },
            {
              value: 'armpublicattachments',
              text: 'Non-Moderated (Public, allow attachments)'
            },
            {
              value: 'armprivate',
              text: 'Non-Moderated (Members Only)'
            },
            {
              value: 'armmoderated',
              text: 'Moderated'
            }
          ],
          searchable: false
        },
        {
          name: 'active',
          order: 'ACTIVE',
          type: 'select',
          width: 6,
          fieldType: 'Boolean',
          options: [
            { value: true, text: 'Yes' },
            { value: false, text: 'No' },
            { value: null, text: 'Both' }
          ],
          searchable: false
        }
      ]
    ]
  }
}
